import { Component, HostBinding, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { EventService } from '@services/event-service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'lv-learner-integration',
  templateUrl: 'learner-integration.component.html',
  styleUrls: ['learner-integration.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet]
})
export class LearnerIntegrationComponent implements OnInit {
  private events = inject(EventService);

  @HostBinding('class.is-monitored') monitored = false;

  ngOnInit() {
    this.events.of('infobar:init').subscribe(() => {
      setTimeout(() => (this.monitored = true), 0); // to avoid ExpressionChangedAfterItHasBeenCheckedError
    });
  }
}
